import {
  communicationsForm,
  instructionalBestPracticesForm,
  integrationsForm,
  keyTeamMembersForm,
  measuringSuccessForm,
  contentPromotionForm,
  professionalLearningForm,
} from "./forms";

const implementationGuideForms = [
  integrationsForm,
  keyTeamMembersForm,
  instructionalBestPracticesForm,
  measuringSuccessForm,
  communicationsForm,
  professionalLearningForm,
  contentPromotionForm,
];

export default implementationGuideForms;
